import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorCodeService, HTTP_STATUS_CODE_ENUM } from '@shared';
import { REQUEST_ENUM } from '@shared';
import { NzMessageService } from 'ng-zorro-antd/message';
import { v4 as uuidv4, v1 } from 'uuid';
import { SessionService, SessionType } from '@shared';
/** Pass untouched request through to the next request handler. */
@Injectable({
  providedIn: 'root',
})
export class CommonInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private nzModalService: NzModalService,
    private nzMessageService: NzMessageService,
    private sessionService: SessionService,
    private readonly errorCodeService: ErrorCodeService
  ) {}
  private getQueryParams(url: string) {
    // 创建URL对象
    const urlObj = new URL(url);
    // 获取查询参数对象
    let queryParams: Record<string, string> = {};
    // 遍历所有查询参数并添加到对象中
    urlObj.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    return queryParams;
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const accessToken = sessionStorage.getItem('access_token'); // localStorage.getItem('access_token'); //this.sessionService.getSessionStorage('access_token');
    const ignoreToken = request.headers.has(REQUEST_ENUM.ignoreToken);

    const currentUser = this.sessionService.get(SessionType.currentUser);
    let userId = this.getQueryParams(location.href)['uuid'] || uuidv4();
    console.log('currentUser', currentUser, userId);
    if (currentUser?.userId) {
      userId = currentUser.userId;
    } else {
      this.sessionService.set(SessionType.currentUser, {
        userId,
      });
    }

    let newHeaders = request.headers
      .set('x-user-id', userId)
      .set('x-app-source', 'IPATIENT');
    let req: HttpRequest<any>;
    //host=hostname+port
    let requestHost = location.host;
    try {
      requestHost = new URL(request.url).host;
    } catch (e) {}
    if (
      accessToken &&
      !request.headers.has('Authorization')
      // &&location.host === requestHost
    ) {
      if (!ignoreToken) {
        newHeaders = newHeaders.set('Authorization', accessToken);
      }

      const clonedRequest = request.clone({ headers: newHeaders });
      return next.handle(clonedRequest).pipe(
        tap((event) => this.tapData(event)),
        catchError((err: HttpErrorResponse) => this.handleData(err))
      );
    } else {
      const clonedRequest = request.clone({ headers: newHeaders });
      return next.handle(clonedRequest).pipe(
        tap((event) => this.tapData(event)),
        catchError((err: HttpErrorResponse) => this.handleData(err))
      );
    }
  }

  private handleData(
    event: HttpResponse<any> | HttpErrorResponse
  ): Observable<any> {
    // 业务处理：一些通用操作
    switch (event.status) {
      case 400:
        this.nzMessageService.error(
          (event as any).error.message || '请求错误，请检查网络或刷新重试'
        );
        return of(event);
      case 401:
        // console.log('not login');
        localStorage.removeItem('access_token'); //this.sessionService.removeSessionStorage('access_token');
        window.location.href = '/';
        return of(event);
      case 403:
        this.nzMessageService.error(
          (event as any).error.message || '身份认证过期'
        );
        this.router.navigate(['/management/noauth/page/403']);
        return of(event);
      case 500:
        this.nzMessageService.error(
          (event as any).error.message || '服务器错误，请检查网络或刷新重试'
        );
        return of(event);
      default:
    }
    return throwError(() => new Error(event.statusText));
  }
  private tapData(event: HttpEvent<{ code: number }>) {
    const self = this;
    if (event instanceof HttpResponse) {
      const errorCode = event.body?.code || 200;
      if (self.errorCodeService.canRedirect(errorCode)) {
        self.captureError(errorCode);
      }
    }
  }
  private async captureError(code: number) {
    const self = this;
    const msg = self.errorCodeService.getMessage(code);
    switch (code) {
      case HTTP_STATUS_CODE_ENUM.UNAUTHORIZED:
        self.nzModalService.error({
          nzContent: msg,
          nzOnOk: () => {
            window.location.reload();
          },
        });
        break;
      default:
        self.nzModalService.error({
          nzContent: msg,
        });
    }
  }
}
